import React, { Component } from 'react';
import SiteLoader from '../layout/site-loader';
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap';
import PageTitle from '../common/page-title/index';
import MyRewards from './my-rewards';
import { getRewards } from '../../actions/reward';

class MyRewardsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabData: [],
      isLoading: true
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getRewards()).then(() => {
      this.setState({ isLoading: false });
    });
  }

  render() {
    const { 
      viewConfigLoaded, hasRewardOutlet, meta, individualRewards
    } = this.props;
    const { isLoading } = this.state;

    if (!viewConfigLoaded || isLoading) {
      return <SiteLoader />;
    }

    return (
      <Grid bsClass="container">
        <Row>
          <Col lg={12}>
            <PageTitle>My Rewards</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
          {viewConfigLoaded &&
            <div id="my-incentives-and-rewards">
              { hasRewardOutlet && <MyRewards individualRewards={individualRewards} staffMembers={meta.staff_members} /> }
            </div>}
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    viewConfigLoaded: state.viewConfig.loaded,
    hasRewardOutlet: state.viewConfig.profile.attributes['has-reward-outlet'],
    individualRewards: state.rewards.individualRewards,
    meta: state.rewards.meta
  };
};

export default connect(mapStateToProps)(MyRewardsPage);



// WEBPACK FOOTER //
// ./src/components/my-rewards/index.jsx